<template>
  <div id="ios-navbar" class="transparent-background">
    <div v-if="withLogo" :class="(deliveryCode && isCash) ? 'logo-left-mobile' : 'logo-left'">
      <div class="circle">
        <img :src="order.workspace.logo" class="logo-workspace">
      </div>
    </div>
    <div v-if="!isMap">
      <div v-if="showWorkspaceName" class="logo-name">
        <span>{{ isWorkspaceName }}</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'IOSNavBar',
  props: {
    title: {
      type: String,
      default: () => ''
    },
    order: {
      type: Object,
      default: () => {}
    },
    withLogo: {
      type: Boolean,
      default: () => false
    },
    isWorkspaceName: {
      type: String,
      default: () => ''
    },
    isMap: {
      type: Boolean,
      default: () => false
    },
    deliveryCode: {
      type: String,
      default: ''
    },
    isCustomLogo: {
      type: Boolean,
      default: false
    },
    showWorkspaceName: {
      type: Boolean,
      default: true
    },
    isCash: {
      type: Boolean,
      default: false
    }
  }
}
</script>
